import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { v4 as uuidv4 } from 'uuid';
import { BOTPRESS_ACTIONS, BOTPRESS_INTERVAL_DELAY, CONTAINER_VISIBILITY_HIDDEN, CONTAINER_VISIBILITY_VISIBLE } from './useBotpress.constants';
import { actionRequiresConversation, createToast, dismissToast, initializeBotpressState } from './useBotpress.utils';
import { asyncSequentialMap } from '../../../../utils/async';
import { BOTPRESS_NOTIFICATION_CONTAINER_ID } from '../../constants';
import { isBotpressConversationReady, isBotpressInitialized } from '../../services/checks';
export default function useBotpress() {
  var botpressState = initializeBotpressState();
  function botpressMethodWrapper(_x, _x2) {
    return _botpressMethodWrapper.apply(this, arguments);
  }
  function _botpressMethodWrapper() {
    _botpressMethodWrapper = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(method, payload) {
      var result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (isBotpressInitialized()) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            result = window.botpress[method](payload);
            _context2.next = 5;
            return result;
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _botpressMethodWrapper.apply(this, arguments);
  }
  function sendEvent(_x3) {
    return _sendEvent.apply(this, arguments);
  }
  function _sendEvent() {
    _sendEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", botpressMethodWrapper('sendEvent', payload));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _sendEvent.apply(this, arguments);
  }
  function sendMessage(_x4) {
    return _sendMessage.apply(this, arguments);
  }
  function _sendMessage() {
    _sendMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
      var content;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            content = payload.content;
            return _context4.abrupt("return", botpressMethodWrapper('sendMessage', content));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _sendMessage.apply(this, arguments);
  }
  function openChat() {
    return _openChat.apply(this, arguments);
  }
  function _openChat() {
    _openChat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", botpressMethodWrapper('open'));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _openChat.apply(this, arguments);
  }
  function closeChat() {
    return _closeChat.apply(this, arguments);
  }
  function _closeChat() {
    _closeChat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", botpressMethodWrapper('close'));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _closeChat.apply(this, arguments);
  }
  function toggleChat() {
    return _toggleChat.apply(this, arguments);
  } // Notification related methods
  function _toggleChat() {
    _toggleChat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", botpressMethodWrapper('toggle'));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _toggleChat.apply(this, arguments);
  }
  function addNotification(messageId, toastId, content) {
    botpressState.notifications.set(messageId, {
      toastId: toastId,
      content: content
    });
  }
  function removeNotification(messageId) {
    var notification = botpressState.notifications.get(messageId);
    if (notification) {
      dismissToast(notification.toastId);
      botpressState.notifications["delete"](messageId);
    }
  }
  function dismissAllNotifications() {
    botpressState.notifications.forEach(function (notification, messageId) {
      removeNotification(messageId);
    });
  }
  function onNotificationClose(messageId, options) {
    if (messageId) {
      removeNotification(messageId);
    }
    if (options.onClose) {
      options.onClose();
    }
  }
  function getNotificationContainer() {
    if (typeof document !== 'undefined') {
      return document.querySelector("#".concat(BOTPRESS_NOTIFICATION_CONTAINER_ID));
    }
    return null;
  }
  function hideNotifications() {
    var container = getNotificationContainer();
    if (container) {
      container.style.visibility = CONTAINER_VISIBILITY_HIDDEN;
    }
  }
  function showNotifications() {
    var container = getNotificationContainer();
    if (container) {
      container.style.visibility = CONTAINER_VISIBILITY_VISIBLE;
    }
  }
  function notify(payload) {
    var _payload$content = payload.content,
      content = _payload$content === void 0 ? '' : _payload$content,
      _payload$options = payload.options,
      options = _payload$options === void 0 ? {} : _payload$options;
    var _options$messageId = options.messageId,
      messageId = _options$messageId === void 0 ? uuidv4() : _options$messageId;
    var callbacks = {
      onNotificationClose: onNotificationClose,
      addNotification: addNotification
    };
    if (!botpressState.notifications.has(messageId)) {
      return createToast(content, options, messageId, callbacks);
    }
    return botpressState.notifications.get(messageId).toastId;
  }

  // Action Queue Management
  function runAction(_x5) {
    return _runAction.apply(this, arguments);
  }
  function _runAction() {
    _runAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref) {
      var _handlerMap;
      var _ref3, id, action, type, _action$payload, payload, handlerMap, handler;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _ref3 = _slicedToArray(_ref, 2), id = _ref3[0], action = _ref3[1];
            type = action.type, _action$payload = action.payload, payload = _action$payload === void 0 ? {} : _action$payload;
            handlerMap = (_handlerMap = {}, _defineProperty(_handlerMap, BOTPRESS_ACTIONS.OPEN_CHAT, openChat), _defineProperty(_handlerMap, BOTPRESS_ACTIONS.CLOSE_CHAT, closeChat), _defineProperty(_handlerMap, BOTPRESS_ACTIONS.TOGGLE, toggleChat), _defineProperty(_handlerMap, BOTPRESS_ACTIONS.SEND_MESSAGE, sendMessage), _defineProperty(_handlerMap, BOTPRESS_ACTIONS.SEND_EVENT, sendEvent), _defineProperty(_handlerMap, BOTPRESS_ACTIONS.NOTIFY, notify), _handlerMap);
            if (isBotpressInitialized()) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return", null);
          case 5:
            if (!(actionRequiresConversation(type) && !isBotpressConversationReady())) {
              _context8.next = 7;
              break;
            }
            return _context8.abrupt("return", null);
          case 7:
            handler = handlerMap[type];
            if (handler) {
              _context8.next = 10;
              break;
            }
            return _context8.abrupt("return", id);
          case 10:
            _context8.prev = 10;
            _context8.next = 13;
            return handler(payload);
          case 13:
            return _context8.abrupt("return", id);
          case 16:
            _context8.prev = 16;
            _context8.t0 = _context8["catch"](10);
            console.error("Botpress: Failed to execute action ".concat(type, ":"), _context8.t0);
            return _context8.abrupt("return", id);
          case 20:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[10, 16]]);
    }));
    return _runAction.apply(this, arguments);
  }
  function removeActionInterval() {
    if (botpressState.checkIntervalId) {
      clearInterval(botpressState.checkIntervalId);
      botpressState.checkIntervalId = null;
    }
  }
  function runActions() {
    return _runActions.apply(this, arguments);
  }
  function _runActions() {
    _runActions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var actions;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (isBotpressInitialized()) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return", null);
          case 2:
            actions = Array.from(botpressState.actionQueue.entries());
            return _context10.abrupt("return", asyncSequentialMap(actions, /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(entry) {
                var removedId;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      _context9.next = 2;
                      return runAction(entry);
                    case 2:
                      removedId = _context9.sent;
                      if (removedId) {
                        botpressState.actionQueue["delete"](removedId);
                      }
                    case 4:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
              return function (_x7) {
                return _ref4.apply(this, arguments);
              };
            }()));
          case 4:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return _runActions.apply(this, arguments);
  }
  function setRunActionsInterval() {
    if (botpressState.checkIntervalId) return;
    botpressState.checkIntervalId = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var actionQueueSize;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            actionQueueSize = botpressState.actionQueue.size;
            if (!(actionQueueSize > 0)) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return runActions();
          case 4:
            if (actionQueueSize === 0) {
              removeActionInterval();
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), BOTPRESS_INTERVAL_DELAY);
  }
  function addActions(_x6) {
    return _addActions.apply(this, arguments);
  }
  function _addActions() {
    _addActions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(actions) {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            // At this time we must always dismiss before adding more to ensure
            //  we do not lose track of callbacks and properly cleanup.
            dismissAllNotifications();
            actions.forEach(function (action) {
              botpressState.actionQueue.set(action.id, action);
            });
            _context11.next = 4;
            return runActions();
          case 4:
            if (botpressState.actionQueue.size > 0) {
              setRunActionsInterval();
            }
          case 5:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _addActions.apply(this, arguments);
  }
  return {
    sendEvent: sendEvent,
    sendMessage: sendMessage,
    openChat: openChat,
    closeChat: closeChat,
    toggleChat: toggleChat,
    notify: notify,
    hideNotifications: hideNotifications,
    showNotifications: showNotifications,
    dismissAllNotifications: dismissAllNotifications,
    addActions: addActions
  };
}